import { Grid, Typography, Card, CardContent, Box } from "@material-ui/core";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import MaskAndValid from "utils/maskAndValid";

const formatValor = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  if (typeof value === "number") {
    return MaskAndValid.maskPrice(value);
  }
  return String(value);
};

const formatData = (value) => {
  if (!value) return "-";
  return MaskAndValid.formattDateBR(value);
};

const formatDadosAdicionais = (dados) => {
  if (!dados || typeof dados !== "object") return null;
  const entries = Object.entries(dados).filter(
    ([, v]) => v !== null && v !== undefined && v !== ""
  );
  if (entries.length === 0) return null;
  return entries.map(([k, v]) => `${k}: ${String(v)}`).join(" · ");
};

/** Primeira chave definida (API atual em snake_case, fallbacks camelCase / legado). */
function pick(obj, ...keys) {
  if (!obj) return undefined;
  for (const k of keys) {
    if (obj[k] !== undefined && obj[k] !== null && obj[k] !== "") {
      return obj[k];
    }
  }
  return undefined;
}

/**
 * Retorno do Report App `consulta-pedido-detail` (Ciclo / wmw).
 * JSON da API: nomes em snake_case (`cabecalho_pedido`, `chave_pedido_ciclo`, …).
 */
export default function InvoicingRulesDisplay({ consultaPedidoDetail }) {
  const d = consultaPedidoDetail || {};
  const cab = pick(
    d,
    "cabecalho_pedido",
    "cabecalhoPedido",
    "Cabecalho"
  );
  const rex = pick(d, "regras_expedicao", "regrasExpedicao", "RegrasExpedicao");
  const rfat = pick(
    d,
    "regras_faturamento",
    "regrasFaturamento",
    "RegrasFaturamento"
  );
  const rfin = pick(
    d,
    "regras_financeiras",
    "regrasFinanceiras",
    "RegrasFinanceiras"
  );
  const itens = pick(d, "itens_pedido", "itensPedido", "ItensPedido") ?? [];
  const nfs = pick(d, "notas_fiscais", "notasFiscais", "NotasFiscais") ?? [];

  const chavePedido = (c) =>
    pick(
      c,
      "chave_pedido_ciclo",
      "chavePedidoCiclo",
      "Cnpedcpt",
      "cnpedcpt"
    );
  const numPed = (c) =>
    pick(c, "numero_pedido", "numeroPedido", "Cnped", "cnped");

  if (!consultaPedidoDetail) {
    return (
      <Card>
        <CardContent>
          <Typography variant="body2" color="textSecondary">
            Nenhum dado do Ciclo foi carregado para este pedido.
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Grid container spacing={3}>
      {cab && (
        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" color="primary" gutterBottom>
                Pedido no Ciclo (cabeçalho)
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <Typography variant="body2" color="textSecondary">
                    Chave pedido Ciclo
                  </Typography>
                  <Typography variant="body1">{chavePedido(cab) || "-"}</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="body2" color="textSecondary">
                    Número pedido
                  </Typography>
                  <Typography variant="body1">
                    {numPed(cab)?.toString() || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="body2" color="textSecondary">
                    Código cliente
                  </Typography>
                  <Typography variant="body1">
                    {pick(
                      cab,
                      "codigo_cliente",
                      "codigoCliente",
                      "Cncli",
                      "cncli"
                    )?.toString() || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="body2" color="textSecondary">
                    Data prazo entrega
                  </Typography>
                  <Typography variant="body1">
                    {formatData(
                      pick(
                        cab,
                        "data_prazo_entrega",
                        "dataPrazoEntrega",
                        "Dnprzetg",
                        "dnprzetg"
                      )
                    )}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="body2" color="textSecondary">
                    Data previsão atendimento
                  </Typography>
                  <Typography variant="body1">
                    {formatData(
                      pick(
                        cab,
                        "data_previsao_atendimento_pedido",
                        "dataPrevisaoAtendimentoPedido",
                        "Dnptaped",
                        "dnptaped"
                      )
                    )}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="body2" color="textSecondary">
                    Tipo rota entrega
                  </Typography>
                  <Typography variant="body1">
                    {pick(
                      cab,
                      "tipo_rota_entrega",
                      "tipoRotaEntrega",
                      "Dtrgt",
                      "dtrgt"
                    ) || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="body2" color="textSecondary">
                    Nome tipo despacho
                  </Typography>
                  <Typography variant="body1">
                    {pick(
                      cab,
                      "nome_tipo_despacho",
                      "nomeTipoDespacho",
                      "Nmtdx",
                      "nmtdx"
                    ) || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="body2" color="textSecondary">
                    Transportadora redespacho
                  </Typography>
                  <Typography variant="body1">
                    {pick(
                      cab,
                      "nome_transportadora_redespacho",
                      "nomeTransportadoraRedespacho",
                      "Nmtrx",
                      "nmtrx"
                    ) || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="body2" color="textSecondary">
                    Emissão NF pedido
                  </Typography>
                  <Typography variant="body1">
                    {pick(
                      cab,
                      "emissao_nota_fiscal_pedido",
                      "emissaoNotaFiscalPedido",
                      "Escnfped",
                      "escnfped"
                    ) || "-"}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      )}

      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Box display="flex" alignItems="center" marginBottom={2}>
              <LocalShippingIcon
                style={{
                  color: "#1976d2",
                  marginRight: "8px",
                  fontSize: "28px",
                }}
              />
              <Typography variant="h4" style={{ color: "#1976d2" }}>
                Regras de expedição
              </Typography>
            </Box>
            <Typography variant="body1" paragraph>
              Motivo vencimento (expedição):{" "}
              {pick(
                rex,
                "texto_motivo_vencimento_expedicao",
                "textoMotivoVencimentoExpedicao",
                "Nmmtvenc"
              ) ??
                pick(
                  cab,
                  "texto_motivo_vencimento_expedicao",
                  "textoMotivoVencimentoExpedicao",
                  "Nmmtvenc"
                ) ??
                "-"}
            </Typography>
            {pick(
              rex,
              "texto_local_roteirizacao_despacho",
              "textoLocalRoteirizacaoDespacho",
              "Nmlocrds"
            ) ? (
              <Typography variant="body1" paragraph>
                Local roteirização despacho:{" "}
                {pick(
                  rex,
                  "texto_local_roteirizacao_despacho",
                  "textoLocalRoteirizacaoDespacho",
                  "Nmlocrds"
                )}
              </Typography>
            ) : null}
            {pick(rex, "texto_via_transporte", "textoViaTransporte", "Nmviatrn") ? (
              <Typography variant="body1" paragraph>
                Via transporte:{" "}
                {pick(rex, "texto_via_transporte", "textoViaTransporte", "Nmviatrn")}
              </Typography>
            ) : null}
            {formatDadosAdicionais(
              pick(rex, "dados_adicionais", "dadosAdicionais", "Dados")
            ) ? (
              <Typography variant="body2" color="textSecondary">
                {formatDadosAdicionais(
                  pick(rex, "dados_adicionais", "dadosAdicionais", "Dados")
                )}
              </Typography>
            ) : null}
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Box display="flex" alignItems="center" marginBottom={2}>
              <ReceiptIcon
                style={{
                  color: "#1976d2",
                  marginRight: "8px",
                  fontSize: "28px",
                }}
              />
              <Typography variant="h4" style={{ color: "#1976d2" }}>
                Regras de faturamento
              </Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Typography variant="body2" color="textSecondary">
                  Motivo faturamento total
                </Typography>
                <Typography variant="body1">
                  {pick(
                    rfat,
                    "texto_motivo_faturamento_total",
                    "textoMotivoFaturamentoTotal",
                    "Nmmtvfattot"
                  ) ??
                    (formatValor(
                      pick(
                        cab,
                        "indicador_motivo_faturamento_total",
                        "indicadorMotivoFaturamentoTotal",
                        "Nmmtvfattot"
                      )
                    ) ||
                      "-")}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="body2" color="textSecondary">
                  Motivo faturamento saldo valor
                </Typography>
                <Typography variant="body1">
                  {pick(
                    rfat,
                    "texto_motivo_faturamento_saldo_valor",
                    "textoMotivoFaturamentoSaldoValor",
                    "Nmmtvfatsdv"
                  ) ??
                    (formatValor(
                      pick(
                        cab,
                        "indicador_motivo_faturamento_saldo_valor",
                        "indicadorMotivoFaturamentoSaldoValor",
                        "Nmmtvfatsdv"
                      )
                    ) ||
                      "-")}
                </Typography>
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography variant="body2" color="textSecondary">
                  Observação faturamento
                </Typography>
                <Typography variant="body1">
                  {pick(
                    rfat,
                    "texto_observacao_faturamento",
                    "textoObservacaoFaturamento",
                    "Nmobsfat"
                  ) ??
                    pick(
                      cab,
                      "observacao_faturamento",
                      "observacaoFaturamento",
                      "Nmobsfat"
                    ) ??
                    "-"}
                </Typography>
              </Grid>
            </Grid>
            {formatDadosAdicionais(
              pick(rfat, "dados_adicionais", "dadosAdicionais", "Dados")
            ) ? (
              <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
                {formatDadosAdicionais(
                  pick(rfat, "dados_adicionais", "dadosAdicionais", "Dados")
                )}
              </Typography>
            ) : null}
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Box display="flex" alignItems="center" marginBottom={2}>
              <AttachMoneyIcon
                style={{
                  color: "#1976d2",
                  marginRight: "8px",
                  fontSize: "28px",
                }}
              />
              <Typography variant="h4" style={{ color: "#1976d2" }}>
                Regras financeiras
              </Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Typography variant="body2" color="textSecondary">
                  Código forma pagamento
                </Typography>
                <Typography variant="body1">
                  {pick(
                    rfin,
                    "codigo_forma_pagamento",
                    "codigoFormaPagamento",
                    "Cnfmapgo"
                  )?.toString() ||
                    pick(
                      cab,
                      "codigo_forma_pagamento",
                      "codigoFormaPagamento",
                      "Cnfmapgo"
                    )?.toString() ||
                    "-"}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="body2" color="textSecondary">
                  Código condição pagamento
                </Typography>
                <Typography variant="body1">
                  {pick(
                    rfin,
                    "codigo_condicao_pagamento",
                    "codigoCondicaoPagamento",
                    "Cnconpgo"
                  )?.toString() ||
                    pick(
                      cab,
                      "codigo_condicao_pagamento",
                      "codigoCondicaoPagamento",
                      "Cnconpgo"
                    )?.toString() ||
                    "-"}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="body2" color="textSecondary">
                  Limite NF por dia
                </Typography>
                <Typography variant="body1">
                  {formatValor(
                    pick(
                      rfin,
                      "valor_limite_notas_fiscais_por_dia",
                      "valorLimiteNotasFiscaisPorDia",
                      "Vnlimnfsdia"
                    )
                  )}
                </Typography>
              </Grid>
            </Grid>
            {formatDadosAdicionais(
              pick(rfin, "dados_adicionais", "dadosAdicionais", "Dados")
            ) ? (
              <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
                {formatDadosAdicionais(
                  pick(rfin, "dados_adicionais", "dadosAdicionais", "Dados")
                )}
              </Typography>
            ) : null}
          </CardContent>
        </Card>
      </Grid>

      {itens.length > 0 && (
        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" color="primary" gutterBottom>
                Itens do pedido (Ciclo)
              </Typography>
              {itens.map((item, idx) => (
                <Box
                  key={`${pick(item, "chave_pedido_ciclo", "chavePedidoCiclo", "Cnpedcpt")}-${pick(item, "sequencia_item", "sequenciaItem", "Cnseqite")}-${idx}`}
                  mb={1.5}
                  pb={1.5}
                  style={{
                    borderBottom:
                      idx < itens.length - 1 ? "1px solid #eee" : undefined,
                  }}
                >
                  <Typography variant="body2">
                    Seq. {pick(item, "sequencia_item", "sequenciaItem", "Cnseqite") ?? "-"} ·
                    Produto {pick(item, "codigo_produto", "codigoProduto", "Cnpdtcpe") ?? "-"} ·{" "}
                    {pick(item, "nome_produto_venda", "nomeProdutoVenda", "Nmpdtven") || "—"}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Qtd. planejada:{" "}
                    {formatValor(
                      pick(item, "quantidade_planejada", "quantidadePlanejada", "Qnpadite")
                    )}{" "}
                    · Valor item: R${" "}
                    {formatValor(pick(item, "valor_item", "valorItem", "Vzite"))}
                    {pick(item, "texto_motivo_vencimento", "textoMotivoVencimento", "Nmmtvenc")
                      ? ` · Motivo venc.: ${pick(item, "texto_motivo_vencimento", "textoMotivoVencimento", "Nmmtvenc")}`
                      : ""}
                  </Typography>
                </Box>
              ))}
            </CardContent>
          </Card>
        </Grid>
      )}

      {nfs.length > 0 && (
        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" color="primary" gutterBottom>
                Notas fiscais (Ciclo)
              </Typography>
              {nfs.map((nf, idx) => (
                <Typography
                  key={`${pick(nf, "numero_nota_fiscal", "numeroNotaFiscal", "Cnnfs")}-${idx}`}
                  variant="body2"
                  paragraph
                >
                  NF {pick(nf, "numero_nota_fiscal", "numeroNotaFiscal", "Cnnfs") ?? "-"} · Emp.{" "}
                  {pick(nf, "codigo_empresa", "codigoEmpresa", "Cnemp") ?? "-"} · Total R${" "}
                  {formatValor(
                    pick(nf, "valor_total_nota_fiscal", "valorTotalNotaFiscal", "Vztotnfs")
                  )}{" "}
                  · {pick(nf, "nome_tipo_despacho", "nomeTipoDespacho", "Nmtdx") || "—"}
                </Typography>
              ))}
            </CardContent>
          </Card>
        </Grid>
      )}
    </Grid>
  );
}
